import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError, retry } from 'rxjs/operators';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { UserProfile } from 'app/main/shared/model/user-profile/user-profile.model';
import { SGF_API } from '../../../../../shared/api/sgf.api';

@Injectable({
  providedIn: 'root'
})
export class UserProfileService {

  private host = `${SGF_API}` + 'sgf/api/public/perfil';
  private permissao = `${SGF_API}` + 'sgf/api/public/permissao';

  constructor(
    private httpClient: HttpClient) {}

  findAll(): Observable<any> {
    return this.httpClient.get<UserProfile[]>(this.host, this.httpOptions())
      .pipe(
        catchError(this.handleError)
      );
  }

  findByNivelUsuario(): Observable<any> {
    const user = JSON.parse(sessionStorage.getItem('funcionario'));
    return this.httpClient.get(`${this.host}/findByNivelUsuario/${user.idUsuario}`, this.httpOptions())
      .pipe(
        catchError(this.handleError)
      )
  }

  create(benefits: any): Observable<any> {
    const body = JSON.stringify(benefits);
    return this.httpClient.post(this.host, body, this.httpOptions())
      .pipe(
        catchError(this.handleError)
      );
  }

  update(benefits: any): Observable<any> {
    const body = JSON.stringify(benefits);
    return this.httpClient.put(this.host, body, this.httpOptions())
      .pipe(
        catchError(this.handleError)
      );
  }

  getPermissao(): Observable<any> {
    return this.httpClient.get<any[]>(this.permissao, this.httpOptions())
      .pipe(
        catchError(this.handleError)
      );
  }

  httpOptions(token?: string): any {
    return {headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': ''
      })
    };
  }

  private handleError(error: HttpErrorResponse): any {
    if (error.error instanceof ErrorEvent) {
      console.error('An error occurred:', error.error.message);
    } else {
      console.error(
        `Backend returned code ${error.status}, ` +
        `body was: ${error.error}`);
    }
    return throwError(
      'Something bad happened; please try again later.');
  }

}
